import { FETCH_ALL_PARAMS } from 'constants/query';
import { useGetPlacesQuery } from 'features/place/services';
import { useMemo, useState } from 'react';
import { configureTableColumns } from 'utils/table-helpers';
import { mapToSelectOptions } from 'utils/filter-select-helpers';
import { useGetProductCategoriesQuery } from 'features/product-category/services';
import { useWorkspace } from 'hooks/useWorkspace';
import { useNavigate, useParams } from 'react-router-dom';
import { ProductsColumns, useProductTableColumns } from '../constants/table-settings';
import useTable from 'hooks/useTable';

const useController = () => {
    const { placeId = '' } = useParams();

    const [activePlace, setActivePlace] = useState<string>(placeId);
    const { websiteId } = useWorkspace();
    const navigate = useNavigate();

    const { data: places } = useGetPlacesQuery({
        ...FETCH_ALL_PARAMS,
        website_id: websiteId,
    });
    const { data: productCategories } = useGetProductCategoriesQuery(FETCH_ALL_PARAMS);

    const handleTabChange = (_: React.SyntheticEvent, newValue: string) => {
        setActivePlace(newValue);
        navigate(`../products/${newValue}`);
    };

    const handleAddProduct = () => {
        navigate(`add/product`);
    };

    const filterSelectOptions = useMemo(() => {
        if (!productCategories) return {};

        return {
            productCategoryName: mapToSelectOptions(productCategories.content),
        };
    }, [productCategories]);

    const { tableSettings } = useTable<ProductsColumns>({
        columns: configureTableColumns(useProductTableColumns(), filterSelectOptions),
        queryIdentifier: 'products',
        renderAddButton: false,
    });

    return {
        tableSettings,
        websiteId,
        places,
        placeId,
        activePlace,
        handleTabChange,
        handleAddProduct,
    };
};

export default useController;
